export const ATUALIZACAO_TEMPLATE_CATEGORIES = [
  {
    id: 'novidades',
    label: 'Novidades',
    description: 'Novos imoveis compativeis com a busca do cliente.',
  },
  {
    id: 'preco',
    label: 'Preco',
    description: 'Reducao ou ajuste de preco em imoveis acompanhados.',
  },
  {
    id: 'disponibilidade',
    label: 'Disponibilidade',
    description: 'Imovel reativado, disponivel ou com agenda liberada.',
  },
];

export const ATUALIZACAO_TEMPLATE_VARIABLES = {
  nome: {
    label: 'Nome do cliente',
    sample: 'Marina',
  },
  bairro: {
    label: 'Bairro de interesse',
    sample: 'Botafogo',
  },
  tipo_imovel: {
    label: 'Tipo de imovel',
    sample: 'apartamentos de 2 quartos',
  },
  finalidade: {
    label: 'Finalidade',
    sample: 'compra',
  },
  faixa_preco: {
    label: 'Faixa de preco',
    sample: 'ate R$ 850 mil',
  },
  link_catalogo: {
    label: 'Link do catalogo',
    sample: 'https://imobiliaria.example/imoveis/botafogo',
  },
  corretor_nome: {
    label: 'Corretor responsavel',
    sample: 'Julia',
  },
  imobiliaria_nome: {
    label: 'Nome da imobiliaria',
    sample: 'Imudei',
  },
};

export const ATUALIZACAO_TEMPLATE_LIBRARY = [
  {
    id: 'novos-imoveis-compativeis',
    categoryId: 'novidades',
    name: 'Novos imoveis compativeis',
    defaultTitle: 'Atualizacao - novos imoveis compativeis',
    channel: 'whatsapp',
    approvedVersion: '2026.07.21',
    approvedAt: '2026-07-21T09:00:00Z',
    whatsappTemplateName: 'lais_atualizacao_novos_imoveis_v20260721',
    body:
      'Oi {{nome}}, chegaram novas opcoes de {{tipo_imovel}} em {{bairro}} para {{finalidade}}.\n' +
      'Separei os destaques aqui: {{link_catalogo}}\n' +
      'Se fizer sentido, responda esta mensagem que eu te ajudo a escolher os melhores.',
    requiredVariables: ['nome', 'tipo_imovel', 'bairro', 'link_catalogo'],
    allowedVariables: [
      'nome',
      'tipo_imovel',
      'bairro',
      'finalidade',
      'faixa_preco',
      'link_catalogo',
      'corretor_nome',
      'imobiliaria_nome',
    ],
  },
  {
    id: 'reducao-preco-interesse',
    categoryId: 'preco',
    name: 'Reducao de preco em interesse salvo',
    defaultTitle: 'Atualizacao - reducao de preco',
    channel: 'whatsapp',
    approvedVersion: '2026.07.21',
    approvedAt: '2026-07-21T09:00:00Z',
    whatsappTemplateName: 'lais_atualizacao_reducao_preco_v20260721',
    body:
      'Oi {{nome}}, um imovel que combina com sua busca em {{bairro}} teve ajuste de preco.\n' +
      'Ele agora esta na faixa de {{faixa_preco}}: {{link_catalogo}}\n' +
      'Quer que eu confira disponibilidade de visita?',
    requiredVariables: ['nome', 'bairro', 'faixa_preco', 'link_catalogo'],
    allowedVariables: [
      'nome',
      'bairro',
      'tipo_imovel',
      'finalidade',
      'faixa_preco',
      'link_catalogo',
      'corretor_nome',
      'imobiliaria_nome',
    ],
  },
  {
    id: 'imovel-reativado-disponivel',
    categoryId: 'disponibilidade',
    name: 'Imovel voltou a ficar disponivel',
    defaultTitle: 'Atualizacao - imovel disponivel novamente',
    channel: 'whatsapp',
    approvedVersion: '2026.07.21',
    approvedAt: '2026-07-21T09:00:00Z',
    whatsappTemplateName: 'lais_atualizacao_imovel_disponivel_v20260721',
    body:
      'Oi {{nome}}, uma opcao em {{bairro}} voltou a ficar disponivel.\n' +
      'Veja os detalhes aqui: {{link_catalogo}}\n' +
      '{{corretor_nome}} pode te ajudar com proximos passos se voce quiser avancar.',
    requiredVariables: ['nome', 'bairro', 'link_catalogo'],
    allowedVariables: [
      'nome',
      'bairro',
      'tipo_imovel',
      'finalidade',
      'faixa_preco',
      'link_catalogo',
      'corretor_nome',
      'imobiliaria_nome',
    ],
  },
];

const TEMPLATE_TOKEN_REGEX = /{{\s*([a-zA-Z0-9_]+)\s*}}/g;

const categoryForTemplate = template =>
  ATUALIZACAO_TEMPLATE_CATEGORIES.find(
    category => category.id === template?.categoryId
  );

export const findAtualizacaoTemplate = templateId =>
  ATUALIZACAO_TEMPLATE_LIBRARY.find(template => template.id === templateId);

export const atualizacaoTemplatesByCategory = categoryId =>
  ATUALIZACAO_TEMPLATE_LIBRARY.filter(
    template => template.categoryId === categoryId
  );

export const extractTemplateVariables = message => {
  const tokens = [...String(message || '').matchAll(TEMPLATE_TOKEN_REGEX)].map(
    match => match[1]
  );

  return [...new Set(tokens)];
};

export const templateVariableDefinitions = template =>
  (template?.allowedVariables || []).map(name => ({
    name,
    token: `{{${name}}}`,
    label: ATUALIZACAO_TEMPLATE_VARIABLES[name]?.label || name,
    required: (template.requiredVariables || []).includes(name),
  }));

export const validateTemplateMessage = (template, message) => {
  if (!template) {
    return [
      {
        code: 'template_required',
        message: 'Selecione um template aprovado antes de enviar para revisao.',
      },
    ];
  }

  const usedVariables = extractTemplateVariables(message);
  const missingRequired = template.requiredVariables.filter(
    variable => !usedVariables.includes(variable)
  );
  const disallowedVariables = usedVariables.filter(
    variable => !template.allowedVariables.includes(variable)
  );

  return [
    ...missingRequired.map(variable => ({
      code: 'missing_required_variable',
      variable,
      message: `Inclua a variavel obrigatoria {{${variable}}}.`,
    })),
    ...disallowedVariables.map(variable => ({
      code: 'disallowed_variable',
      variable,
      message: `Remova a variavel nao permitida {{${variable}}}.`,
    })),
  ];
};

export const renderTemplatePreview = (message, values = {}) =>
  String(message || '').replace(TEMPLATE_TOKEN_REGEX, (token, variable) => {
    const sample = ATUALIZACAO_TEMPLATE_VARIABLES[variable]?.sample;
    return values[variable] || sample || token;
  });

export const buildTemplateMetadataPayload = ({
  template,
  finalMessage,
  recordedAt = new Date().toISOString(),
}) => {
  if (!template) return {};

  const category = categoryForTemplate(template);

  return {
    id: template.id,
    name: template.name,
    category_id: template.categoryId,
    category_label: category?.label,
    approved_version: template.approvedVersion,
    approved_at: template.approvedAt,
    channel: template.channel,
    whatsapp_template_name: template.whatsappTemplateName,
    source: 'atualizacao_template_library',
    template_body: template.body,
    final_message: finalMessage,
    recorded_at: recordedAt,
    variables: {
      allowed: template.allowedVariables,
      required: template.requiredVariables,
      used: extractTemplateVariables(finalMessage),
    },
  };
};

const readTemplateMetadata = disparo =>
  disparo?.filtros?.template_metadata ||
  disparo?.filtros?.templateMetadata ||
  disparo?.approval_snapshot?.template_metadata ||
  disparo?.approval_snapshot?.templateMetadata ||
  disparo?.approval_snapshot?.filtros?.template_metadata ||
  disparo?.approval_snapshot?.filtros?.templateMetadata ||
  disparo?.resultado?.template_metadata ||
  disparo?.resultado?.templateMetadata ||
  null;

export const templateUsageFromDisparo = disparo => {
  const metadata = readTemplateMetadata(disparo);
  if (!metadata) return null;

  const template = findAtualizacaoTemplate(metadata.id);
  const category = categoryForTemplate(template);

  return {
    id: metadata.id,
    label: metadata.name || template?.name || metadata.id,
    categoryLabel:
      metadata.category_label || metadata.categoryLabel || category?.label,
    approvedVersion:
      metadata.approved_version ||
      metadata.approvedVersion ||
      template?.approvedVersion,
    source: metadata.source,
    templateBody:
      metadata.template_body || metadata.templateBody || template?.body || '',
    finalMessage:
      metadata.final_message ||
      metadata.finalMessage ||
      disparo?.mensagem ||
      disparo?.approval_snapshot?.mensagem ||
      '',
    variables: metadata.variables || {},
  };
};

const normalizedLines = value =>
  String(value || '')
    .trim()
    .split(/\n+/)
    .map(line => line.trim())
    .filter(Boolean);

export const buildTemplateReviewDiff = (templateBody, finalMessage) => {
  const templateLines = normalizedLines(templateBody);
  const finalLines = normalizedLines(finalMessage);
  const maxLines = Math.max(templateLines.length, finalLines.length);

  return Array.from({ length: maxLines }, (_, index) => {
    const template = templateLines[index] || '';
    const final = finalLines[index] || '';
    let kind = 'added';
    if (template === final) {
      kind = 'unchanged';
    } else if (template && final) {
      kind = 'changed';
    } else if (template) {
      kind = 'removed';
    }

    return {
      key: `${index}-${kind}-${template}-${final}`,
      kind,
      template,
      final,
    };
  });
};

export const templateReviewDiffFromDisparo = disparo => {
  const usage = templateUsageFromDisparo(disparo);
  if (!usage) return [];

  return buildTemplateReviewDiff(usage.templateBody, usage.finalMessage);
};
